import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';
import {User} from '../../../../classes/User';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input-gg';
import {LocalStorageService} from '../../../../services/local-storage.service';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {LanguageService} from '../../../../services/language.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Component({
  selector: 'app-phone-update',
  styleUrls: ['./phone-update.component.scss'],
  templateUrl: './phone-update.component.html',
})
export class PhoneUpdateComponent implements OnInit {

  public currentUser: User;
  public isSuccess: boolean;
  public errorMessage: string;

  public phoneForm: FormGroup;

  public SearchCountryField = SearchCountryField;
  public CountryISO = CountryISO;
  public PhoneNumberFormat = PhoneNumberFormat;

  constructor(private httpClient: HttpClient,
              private formBuilder: FormBuilder,
              private router: Router,
              private localStorageService: LocalStorageService,
              public languageService: LanguageService) {
    this.currentUser = this.localStorageService.getUser();
  }

  ngOnInit(): void {

    console.log(this.currentUser);
    this.phoneForm = this.formBuilder.group({
      phone: [this.currentUser ? this.currentUser.phone.value : null, Validators.required]
    });
  }

  public onSubmit(): void {
    this.httpClient.post(`${environment.backendApiUrl}/v1/users/phone`,
      {phone: this.phoneForm.controls.phone.value.e164Number},
      httpOptions)
      .subscribe({
        next: () => {
          this.isSuccess = true;
          this.router.navigate(['/user']);
        },
        error: (err) => {
          this.isSuccess = false;
          this.errorMessage = err.error.message;
        },
      });
  }

  cancel(): void {
    this.router.navigate(['/user']);
  }
}
